module.exports = __webpack_public_path__ + "static/media/user1.0a33b37f.jpg";